import React from 'react';
import {View, StyleSheet} from 'react-native';

const ProductCardSkeleton: React.FC = () => {
  return (
    <View style={stijlen.container}>
      <View style={stijlen.imageContainer} />
      <View style={stijlen.content}>
        <View style={stijlen.titleSkeleton} />
        <View style={stijlen.brandSkeleton} />
        <View style={stijlen.footer}>
          <View style={stijlen.gradeSkeleton} />
        </View>
      </View>
    </View>
  );
};

const stijlen = StyleSheet.create({
  container: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    overflow: 'hidden',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    marginBottom: 16,
  },
  imageContainer: {
    width: '100%',
    height: 150,
    backgroundColor: '#E0E0E0',
  },
  content: {
    padding: 16,
  },
  titleSkeleton: {
    height: 20,
    backgroundColor: '#E0E0E0',
    borderRadius: 4,
    marginBottom: 8,
    width: '80%',
  },
  brandSkeleton: {
    height: 16,
    backgroundColor: '#E0E0E0',
    borderRadius: 4,
    marginBottom: 12,
    width: '50%',
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  gradeSkeleton: {
    width: 60,
    height: 60,
    borderRadius: 30,
    backgroundColor: '#E0E0E0',
  },
});

export default ProductCardSkeleton;
